import type { AttachmentRef } from '@/domain/funnel/node-system';
import { apiDelete, apiGet } from '@/infrastructure/api-client';

export async function listNodeAttachments(
  funnelId: string,
  nodeId: string,
): Promise<AttachmentRef[]> {
  const result = await apiGet<{ attachments: AttachmentRef[] }>(
    `/api/funnels/${funnelId}/nodes/${nodeId}/attachments`,
  );
  return result.attachments;
}

export async function uploadNodeAttachment(
  funnelId: string,
  nodeId: string,
  file: File,
): Promise<AttachmentRef> {
  const form = new FormData();
  form.set('file', file);
  const path = `/api/funnels/${funnelId}/nodes/${nodeId}/attachments`;
  const response = await fetch(path, { method: 'POST', body: form, credentials: 'include' });
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      error?: { message?: string };
    } | null;
    throw new Error(body?.error?.message ?? 'Attachment upload failed.');
  }
  return ((await response.json()) as { attachment: AttachmentRef }).attachment;
}

export function attachmentDownloadUrl(id: string): string {
  return `/api/attachments/${id}`;
}
export async function removeAttachment(id: string): Promise<void> {
  await apiDelete(`/api/attachments/${id}`);
}
